import { ExpressionToken } from '../SearchBar';

export interface NotTreeExpression<T = unknown> {
  expr: TreeExpression<T> | undefined;
  operator: 'not';
}

export interface AndTreeExpression<T = unknown> {
  exprs: TreeExpression<T>[];
  operator: 'and';
}

export interface OrTreeExpression<T = unknown> {
  exprs: TreeExpression<T>[];
  operator: 'or';
}

export type TreeExpression<T = unknown> =
  | NotTreeExpression<T>
  | AndTreeExpression<T>
  | OrTreeExpression<T>
  | ExpressionToken<T>;

export type IdNotTreeExpression<T = unknown> = Omit<NotTreeExpression<T>, 'expr'> & {
  uuid: string;
  parentUuid: string | undefined;
  expr: IdTreeExpression<T> | undefined;
  isGhost: boolean;
};

export type IdAndTreeExpression<T = unknown> = Omit<AndTreeExpression<T>, 'exprs'> & {
  uuid: string;
  parentUuid: string | undefined;
  exprs: IdTreeExpression<T>[];
  isGhost: boolean;
};

export type IdOrTreeExpression<T = unknown> = Omit<OrTreeExpression<T>, 'exprs'> & {
  uuid: string;
  parentUuid: string | undefined;
  exprs: IdTreeExpression<T>[];
  isGhost: boolean;
};

export type IdExpressionToken<T = unknown> = ExpressionToken<T> & {
  uuid: string;
  parentUuid: string | undefined;
  isGhost: boolean;
};

export type IdIncompleteExpressionToken<T = unknown> = {
  operator: 'incomplete_expression';
  uuid: string;
  parentUuid: string | undefined;
  isGhost: boolean;
  fallbackExpression: IdTreeExpression<T> | undefined;
  moduleId: string;
};

export type IdTreeExpression<T = unknown> =
  | IdNotTreeExpression<T>
  | IdAndTreeExpression<T>
  | IdOrTreeExpression<T>
  | IdExpressionToken<T>
  | IdIncompleteExpressionToken<T>;

export const EMPTY_EXPRESSION_ID = 'empty_expr';
export const OR_NEW_ID = 'or_new';
export const AND_NEW_ID = 'and_new';
export const NOT_NEW_ID = 'not_new';
export const EXPRESSION_NEW_ID = 'expression_new_';
